import { Button, Popover } from 'antd';
import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { isUserManagedBySupplier } from '../../utils/AuthUtils';
import { LockOutlined } from '@ant-design/icons';

const OWButtonWithSupplierManagedLock: FC<any> = ({
	children,
	currentUser,
	hideLockIcon,
	...props
}): React.ReactElement => {
	const isLocked = useMemo(() => isUserManagedBySupplier(currentUser), [currentUser]);

	const onSupportClick = () => window.Intercom && window.Intercom('show');

	const popoverContent = (
		<div>
			Contact{' '}
			<span
				className="text-blue-600 underline visited:text-purple-600 hover:cursor-pointer hover:text-blue-800"
				onClick={onSupportClick}
			>
				support
			</span>{' '}
			to access this feature
		</div>
	);

	return (
		<Popover content={isLocked ? popoverContent : ''} trigger="hover">
			<Button {...props} disabled={isLocked}>
				<>
					<span>{children}</span>
					{!hideLockIcon && isLocked ? (
						<span className="ml-2">
							<LockOutlined translate="" />
						</span>
					) : null}
				</>
			</Button>
		</Popover>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(OWButtonWithSupplierManagedLock);
